import r from "react";
import o from "prop-types";
import k from "classnames";
import { mintelRed400 as g } from "mintel-tokens";
import { u as x } from "./ThemeProvider--i7ESlT5.es.js";
import { T as i } from "./index-Dd-4N6BE.es.js";
import { I as C } from "./Icon-BuIPTPJn.es.js";
import './Checkbox.css';const I = "#666", y = "#ccc", $ = "#fff", v = "#026fd9", p = "#c88c00", w = "#458415", S = "#ac2f96", N = "#385442", q = "#4d4e8c", z = "Checkbox-default-module__container___q23gz", B = "Checkbox-default-module__error___n-fZf", E = "Checkbox-default-module__checkbox___t-GoR", D = "Checkbox-default-module__selected___BgolO", O = "Checkbox-default-module__label___lNqhn", K = "Checkbox-default-module__blue___I0sgN", L = "Checkbox-default-module__gold___78Dnm", T = "Checkbox-default-module__green___o2QUK", R = "Checkbox-default-module__purple___OIumH", V = "Checkbox-default-module__mint___rqsxb", P = "Checkbox-default-module__lavender___M-qV4", m = {
  border: I,
  disabled: y,
  white: $,
  blueIcon: v,
  goldIcon: p,
  greenIcon: w,
  purpleIcon: S,
  mintIcon: N,
  lavenderIcon: q,
  container: z,
  error: B,
  checkbox: E,
  selected: D,
  label: O,
  blue: K,
  gold: L,
  green: T,
  purple: R,
  mint: V,
  lavender: P
}, X = "#666", j = "#ccc", F = "#fff", H = "#008eff", M = "#ffa343", G = "#00857a", Q = "#ff0076", U = "#d500f9", Z = "Checkbox-compere-module__container___52pBO", A = "Checkbox-compere-module__error___pFT2L", J = "Checkbox-compere-module__checkbox___UjQ3l", W = "Checkbox-compere-module__selected___BFwEt", Y = "Checkbox-compere-module__label___bDqqq", ee = "Checkbox-compere-module__blue___vldX7", oe = "Checkbox-compere-module__gold___MNS6G", le = "Checkbox-compere-module__green___i-8B-", ce = "Checkbox-compere-module__pink___qjS1q", ne = "Checkbox-compere-module__purple___XHVyX", te = {
  border: X,
  disabled: j,
  white: F,
  blueIcon: H,
  "deep-purpleIcon": "#8e3eff",
  goldIcon: M,
  greenIcon: G,
  pinkIcon: Q,
  purpleIcon: U,
  container: Z,
  error: A,
  checkbox: J,
  selected: W,
  label: Y,
  blue: ee,
  "deep-purple": "Checkbox-compere-module__deep-purple___-SXdB",
  gold: oe,
  green: le,
  pink: ce,
  purple: ne
}, re = {
  default: m,
  compere: te
}, _ = {
  default: ["blue", "gold", "green", "purple", "mint", "lavender"],
  compere: ["blue", "deep-purple", "gold", "green", "pink", "purple"]
}, de = (e) => re[e] || m, ae = (e) => _[e] || _.default, _e = (e, n) => n.includes(e) ? e : "green", ie = (e) => i[e] || i.Body2, be = (e, n) => {
  let l;
  return e === !0 ? l = "checkbox_checked" : e === "mixed" ? l = "checkbox_mixed" : n && (l = "checkbox_unchecked"), l;
}, se = (e, n, l, c, d, a) => {
  let t;
  return n ? t = d.disabled : [!0, "mixed"].includes(e) ? t = d[`${a}Icon`] : c ? t = g : l && (t = d.border), t;
}, b = r.forwardRef((e, n) => {
  const l = x(), c = de(l), d = ae(l), a = _e(e.color, d), t = ie(e.labelVariant), f = se(
    e.checked,
    e.disabled,
    e.border,
    e.error,
    c,
    a
  ), s = be(e.checked, e.border), h = e.error && !e.checked ? c.error : c[a];
  return /* @__PURE__ */ r.createElement(
    "div",
    {
      "aria-checked": e.checked,
      "aria-disabled": e.disabled,
      "aria-labelledby": e.label && e.id ? `${e.id}-label` : e.ariaLabelledBy,
      className: k(c.container, h, {
        [c.selected]: e.checked !== !1
      }),
      id: e.id,
      onClick: e.disabled ? null : e.onChange,
      onKeyPress: e.disabled ? () => {
      } : (u) => {
        [" ", "Spacebar"].includes(u.key) && (u.preventDefault(), e.onChange());
      },
      onKeyDown: e.onKeyDown,
      tabIndex: e.disabled ? -1 : e.tabIndex,
      ref: n,
      role: "checkbox"
    },
    /* @__PURE__ */ r.createElement(
      "div",
      {
        className: c.checkbox,
        style: {
          width: `${e.size}px`,
          height: `${e.size}px`,
          fontSize: `${e.size}px`
          // req to make box-shadow size relative
        }
      },
      s && /* @__PURE__ */ r.createElement(
        C,
        {
          color: f,
          alt_color: c.white,
          name: s,
          size: e.size
        }
      )
    ),
    e.label && /* @__PURE__ */ r.createElement(
      "label",
      {
        className: c.label,
        id: e.id ? `${e.id}-label` : void 0,
        htmlFor: e.id
      },
      /* @__PURE__ */ r.createElement(
        t,
        {
          color: e.labelColor,
          theme: l,
          responsive: !0
        },
        e.label
      )
    )
  );
});
b.displayName = "Checkbox";
b.propTypes = {
  /** Maps to the `aria-checked` value of the div with role="checkbox" */
  checked: o.oneOf([!0, !1, "mixed"]).isRequired,
  /** The color of the chip. 'deep-purple' and 'pink' are Compere theme only, 'lavender' and 'mint' are default theme only.
   * If an invalid color/theme combination is provided, defaults to 'green' */
  color: o.oneOf([..._.compere, ..._.default]),
  /** Whether or not the checkbox is disabled */
  disabled: o.bool,
  /** id for the div with role="checkbox".
   * If both this and label are specified, the aria-labelledby prop will be populated with the id of the label
   * on the div with role="checkbox". */
  id: o.string,
  /** The input checkbox callback, called with the click/keypress event */
  onChange: o.func,
  /** The width and height of the checkbox in pixels. */
  size: o.number,
  /** The checkbox border will be displayed when this is true.
   * Note that the checkbox will not be visible at all in its unchecked state when this prop is false,
   * so there should be another way to toggle the state of the checkbox than with the `onChange` prop in this case. */
  border: o.bool,
  /** onKeyDown event handler passed to the interactive div of the checkbox, separate from the onChange which gets triggered on Spacebar  */
  onKeyDown: o.func,
  /** Optional text color for the textbox label. If none give, default text color will be used.  */
  labelColor: o.string,
  /** The MRUI Text variant to be used by the label, e.g. "Body2" or "Heading1 */
  labelVariant: o.oneOf(Object.keys(i)),
  /** The tabIndex of the div with role="checkbox". Exposed so it may be set to -1 when a roving tabIndex is being used.  */
  tabIndex: o.number,
  /** Text of the checkbox's label */
  label: o.string,
  /** If true, checkbox will have red error style */
  error: o.bool,
  /** HTML id of alternate label component */
  ariaLabelledBy: o.string
};
b.defaultProps = {
  border: !0,
  color: "green",
  disabled: !1,
  id: void 0,
  onChange: () => null,
  onKeyDown: void 0,
  size: 20,
  labelColor: void 0,
  labelVariant: "Heading5",
  tabIndex: 0,
  label: null,
  error: !1,
  ariaLabelledBy: void 0
};
export {
  b as C
};
